module.exports = __webpack_public_path__ + "static/media/icon_open_workspace_dim.a3ff4656.svg";